import List from "./List";
import ListCard from "./ListCard";

export default { List, ListCard };
